import React__default, { useState } from 'react';
import classNames from './../external_lib/classnames/index.js';
import Typography from './Typography.js';
import CrossIcon from '../assets/icons/cross.icon.js';

function Capsule(_a) {
    var onCancel = _a.onCancel, onClick = _a.onClick, classes = _a.classes, _b = _a.label, label = _b === void 0 ? '' : _b, _c = _a.type, type = _c === void 0 ? 'default' : _c, _d = _a.variant, variant = _d === void 0 ? 'default' : _d, _e = _a.status, status = _e === void 0 ? 'default' : _e, _f = _a.crossColor, crossColor = _f === void 0 ? 'white' : _f;
    var _g = useState(true), visible = _g[0], setVisible = _g[1];
    var handleOnClick = function (event) {
        event.stopPropagation();
        onClick && onClick(label);
    };
    var handleOnCancel = function (event) {
        event.stopPropagation();
        if (variant === 'default')
            setVisible(false);
        onCancel && onCancel();
    };
    if (variant === 'default' && !visible) {
        return null;
    }
    return (React__default.createElement("div", { onClick: handleOnClick, className: classNames('capsule', classes, type, status) },
        React__default.createElement(Typography, { variant: "tags", classes: "capsule-label" }, label),
        onCancel ? (React__default.createElement(CrossIcon, { onClick: handleOnCancel, color: crossColor })) : null));
}

export { Capsule as default };
//# sourceMappingURL=Capsule.js.map
